
import React from 'react'
import Heading from './Heading'
import Paragraph from './Paragraph'
import Box from './Box'

// TODO: convert to vbox

/**
 * Placeholder component.
 */

export default function Placeholder({ title, text, children }) {
  return <Box className="Empty">
    <Box className="content" animate="show">
      <Heading size={4}>{title}</Heading>
      <Paragraph size={2} marginTop={4} textAlign="center" muted>{text}</Paragraph>
      <Box className="actions">
        {children}
      </Box>
    </Box>
  </Box>
}